import http from "./request";

// 查询分套结果列表
export function getAnalysisCapacityList(id) {
	return http(`/project/esAnalysisCapacityList/${id}`, {
		method: "GET",
		params: {}
	});
}

// 开始经济分析
export function startEconomic(params) {
	return http(`/economic/begin`, {
		method: "POST",
		params
	});
}

// 查询经济分析结果
export function getEconomicData(id) {
	return http(`/economic/result/${id}`, {
		method: "GET",
		params: {}
	});
}

// 生成报告
export function saveToReport(id) {
	return http(`/project/createReport/${id}`, {
		method: "GET",
		params: {}
	});
}
